import React from 'react';
import PropTypes from 'prop-types';
import { Box, Link, Typography } from '@mui/material';
import { renderStatus } from '../../../components/v2/cell-renderers/status';
import { statusToChip } from './constants';

export const cellContentSx = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  height: '100%',
  minWidth: 0,
  width: '100%',
};

const displayValue = (value) => {
  if (value == null || value === '') return '—';
  return value;
};

const formatCount = (value) => {
  if (value == null || value === '') return '—';
  const n = Number(value);
  return Number.isNaN(n) ? '—' : String(n);
};

export const LabeledLine = ({ label, value }) => (
  <Typography variant="body2" noWrap title={value != null && value !== '' ? String(value) : undefined}>
    <Box component="span" sx={{ fontWeight: 700 }}>
      {label}
    </Box>
    {displayValue(value)}
  </Typography>
);

LabeledLine.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export const renderTipoServicoSubtipo = (row) => (
  <Box sx={cellContentSx}>
    <LabeledLine label="Tipo Serviço: " value={row.tipoServicoNome} />
    <LabeledLine label="Subtipo: " value={row.subtipoNome} />
  </Box>
);

const nsirLinkSx = {
  color: 'info.main',
  fontWeight: 600,
  textDecoration: 'underline',
  verticalAlign: 'baseline',
  '&:hover': {
    color: 'info.dark',
    textDecoration: 'underline',
  },
};

const renderNsirValue = (row) => {
  const { nsirId, nsirCodigo } = row;
  if (!nsirCodigo) return '—';
  if (!nsirId) return nsirCodigo;
  const href = `${window.location.origin}/v2/nsir/${nsirId}`;
  return (
    <Link
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      sx={nsirLinkSx}
    >
      {nsirCodigo}
    </Link>
  );
};

const nsirStatusCellSx = {
  ...cellContentSx,
  alignItems: 'center',
  textAlign: 'center',
  width: '100%',
};

export const renderNsirStatus = (row) => (
  <Box sx={nsirStatusCellSx}>
    <Typography
      variant="body2"
      noWrap
      sx={{
        display: 'flex',
        minWidth: 0,
        width: '100%',
      }}
    >
      {renderNsirValue(row)}
    </Typography>
    <Typography
      variant="body2"
      component="div"
      sx={{
        display: 'flex',
        width: '100%',
        pt: 0.3,
      }}
    >
      {row.status ? renderStatus(statusToChip(row.status)) : '—'}
    </Typography>
  </Box>
);

export const renderMalhaGerencia = (row) => (
  <Box sx={cellContentSx}>
    <LabeledLine label="Malha: " value={row.malhaNome} />
    <LabeledLine label="Gerência: " value={row.gerenciaNome} />
  </Box>
);

export const renderLocalRede = (row) => (
  <Box sx={cellContentSx}>
    <LabeledLine label="Polo: " value={row.poloNome} />
    <LabeledLine label="Subestação: " value={row.subestacaoNome} />
    <LabeledLine label="Alimentador: " value={row.alimentadorNome} />
  </Box>
);

export const renderVolumes = (row) => (
  <Box sx={cellContentSx}>
    <Typography variant="body2">
      <Box component="span" sx={{ fontWeight: 700 }}>
        Total Digitados:{' '}
      </Box>
      {formatCount(row.totalDigitados)}
    </Typography>
    <Typography variant="body2">
      <Box component="span" sx={{ fontWeight: 700 }}>
        Pendentes:{' '}
      </Box>
      {formatCount(row.pendentes)}
    </Typography>
  </Box>
);
